import * as THREE from 'three';

// ─── Page-edge striation texture ───────────────────────────────────
function makeStriationTexture(vertical: boolean): THREE.CanvasTexture {
  const w = 256,
    h = 256;
  const cvs = document.createElement('canvas');
  cvs.width = w;
  cvs.height = h;
  const ctx = cvs.getContext('2d')!;
  ctx.fillStyle = '#efe9dc';
  ctx.fillRect(0, 0, w, h);
  const n = 150;
  for (let i = 0; i < n; i++) {
    const p = (i / n) * (vertical ? w : h);
    const shade = 200 + Math.floor(Math.random() * 40) - 10;
    ctx.strokeStyle = `rgba(${shade - 40},${shade - 50},${shade - 65},0.5)`;
    ctx.lineWidth = 0.7;
    ctx.beginPath();
    if (vertical) {
      ctx.moveTo(p, 0);
      ctx.lineTo(p, h);
    } else {
      ctx.moveTo(0, p);
      ctx.lineTo(w, p);
    }
    ctx.stroke();
  }
  const t = new THREE.CanvasTexture(cvs);
  t.encoding = THREE.sRGBEncoding;
  return t;
}

export const striationV = makeStriationTexture(true);
export const striationH = makeStriationTexture(false);

// ─── Gradient backdrop texture ─────────────────────────────────────
export function makeGradientBg(): THREE.CanvasTexture {
  const cvs = document.createElement('canvas');
  cvs.width = 16;
  cvs.height = 256;
  const ctx = cvs.getContext('2d')!;
  const g = ctx.createLinearGradient(0, 0, 0, 256);
  g.addColorStop(0, '#2a2c34');
  g.addColorStop(0.55, '#15161b');
  g.addColorStop(1, '#0a0a0c');
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, 16, 256);
  const t = new THREE.CanvasTexture(cvs);
  t.encoding = THREE.sRGBEncoding;
  return t;
}
